export function toggleDetails() {
  return {
    type: '@settings/TOGGLE_DETAILS',
  };
}
